
const buyButtonStyles = {
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    color: '#ffffff',
    backgroundColor: 'rgb(95, 127, 255)',
    borderRadius: '5px',
    border: '1px solid transparent',
    padding: '0.5rem',
    fontSize: '1rem',
    letterSpacing: '0.6px',
    boxShadow: '0px 1px 2px rgba(190, 190, 190, 0.5)',
    fontFamily: "'Comic Neue','cursive'",

    "&:hover": {
        textDecoration: 'underline',
        boxShadow: '0px 1px 2px 2px rgba(190, 190, 190, 0.5)',
        opacity: '0.85',
        color: '#ffffff'
    },
    "&:active": {
        textDecoration: 'underline',
        boxShadow: '0px 1px 2px 2px rgba(190, 190, 190, 0.5)',
        opacity: '0.85',
        color: '#ffffff'
    },
    "&:focus": {
        textDecoration: 'underline',
        boxShadow: '0px 1px 2px 2px rgba(190, 190, 190, 0.5)',
        opacity: '0.85',
        color: '#ffffff'
    }
  }
  
  const coffeeImage = {
    height: '2vh',
    boxShadow: 'none',
    border: 'none',
    verticalAlign: 'middle'
  }
  
  const coffeeButtonTextStyles = {
    marginLeft: '15px',
    fontSize: '0.8rem',
    verticalAlign: 'middle'
  }

export const BuyMeACoffeeButton = () => {
    return (
        <a id="buyCoffeeButton" style={buyButtonStyles} target="_blank" rel="noreferrer noopener" href="https://www.buymeacoffee.com/dubravkoboa">
            <img id="coffeeImage" style={coffeeImage} src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg" alt="Buy me a coffee" height="35" />
            <span id="coffeeButtonText" style={coffeeButtonTextStyles}>Buy me a coffee</span>
        </a>
    );
};
